<script setup lang="ts">
export type DecorShapeKind =
  "star" | "star-outline" | "triangle-right" | "triangle-up" | "dot" | "ring";

defineProps<{
  shape: DecorShapeKind;
  color: string;
  styles: Record<string, string>;
}>();
</script>

<template>
  <svg
    v-if="shape === 'star'"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    class="absolute"
    :style="{ ...styles, color }"
  >
    <path
      d="M12 0c1 8 4 11 12 12-8 1-11 4-12 12-1-8-4-11-12-12 8-1 11-4 12-12Z"
      fill="currentColor"
    />
  </svg>
  <svg
    v-else-if="shape === 'star-outline'"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    class="absolute"
    :style="{ ...styles, color }"
  >
    <path
      d="M12 1c.8 7 4 10.2 11 11-7 .8-10.2 4-11 11-.8-7-4-10.2-11-11 7-.8 10.2-4 11-11Z"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
    />
  </svg>
  <svg
    v-else-if="shape === 'triangle-right'"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    class="absolute"
    :style="{ ...styles, color }"
  >
    <path d="M3 12 21 3 21 21Z" fill="currentColor" />
  </svg>
  <svg
    v-else-if="shape === 'triangle-up'"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    class="absolute"
    :style="{ ...styles, color }"
  >
    <path d="M12 3 22 21 2 21Z" fill="currentColor" />
  </svg>
  <span
    v-else-if="shape === 'dot'"
    class="absolute rounded-full"
    :style="{ ...styles, backgroundColor: color }"
  ></span>
  <span
    v-else
    class="absolute rounded-full border-2"
    :style="{ ...styles, borderColor: color }"
  ></span>
</template>
